import { render, staticRenderFns } from "./CartDetail.vue?vue&type=template&id=2ca057d6&"
import script from "./CartDetail.vue?vue&type=script&lang=js&"
export * from "./CartDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports